import { StyledEditableText } from './styles';
import { useTruncationTooltip } from 'components/Kizen/Tooltip';

const EditableTextEllipsisWithTooltip = ({ description, ...props }) => {
  const [nameTooltipProps, nameTooltip] = useTruncationTooltip({
    description: description,
  });
  return (
    <>
      {nameTooltip}
      <StyledEditableText {...props} {...nameTooltipProps} />
    </>
  );
};
export default EditableTextEllipsisWithTooltip;
